export const MAX_RE_FETCHES = 1;

export const isSocketHangUpError = ({ data }: {
    data?: any
}) => typeof data === 'string' && data.includes('socket hang up');

export const isAPIError = ({ details }: {
    details?: any
}) => Object.keys(details || {}).includes('apiError') && details['apiError'] === true;

export const fetchAllValues = async <T>(
    callback: (offset: number, limit: number) => Promise<T[]> | null,
    options?: { numPerRequest?: number; }
): Promise<T[]> => {
    const { numPerRequest } = options || {};
    const values: T[] = [];
    const limit = numPerRequest ?? 100;
    const offset = 0;

    let skip = offset;
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        const result = await callback(skip, limit);
        if (result.length === 0) break;
        values.push(...result);
        skip += limit;
    }
    return values;
}